import { render, staticRenderFns } from "./TableBalanceCurrent.vue?vue&type=template&id=253131a3&"
import script from "./TableBalanceCurrent.vue?vue&type=script&lang=js&"
export * from "./TableBalanceCurrent.vue?vue&type=script&lang=js&"
import style0 from "./TableBalanceCurrent.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports